<!-- src/views/new-tip/CampaignDetail.vue -->
<template>
  <v-container fluid v-if="campaign">
    <div class="d-flex align-center mb-4">
      <v-btn icon :to="{ name: 'new-tip.campaigns.index' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div class="ml-2">
        <h1 class="text-h5 font-weight-medium">{{ campaign.name }}</h1>
        <new-tip-status-badge type="campaign" :value="campaign.status" />
      </div>
      <v-spacer />
      <v-btn outlined :to="{ name: 'new-tip.campaigns.assignments', params: { id: campaign.id } }">
        <v-icon left>mdi-account-multiple</v-icon>
        Gérer les affectations
      </v-btn>
      <v-btn color="primary" class="ml-2" :to="{ name: 'new-tip.campaigns.edit', params: { id: campaign.id } }">
        <v-icon left>mdi-pencil</v-icon>
        Modifier
      </v-btn>
    </div>

    <v-row>
      <v-col cols="12" md="8">
        <v-card outlined>
          <v-card-title class="text-subtitle-1">Informations</v-card-title>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <div class="text-caption grey--text">Période</div>
                <div>{{ formatDate(campaign.start_date) }} → {{ formatDate(campaign.end_date) }}</div>
              </v-col>
              <v-col cols="6">
                <div class="text-caption grey--text">Créée par</div>
                <div>{{ creatorName }}</div>
              </v-col>
              <v-col cols="12" v-if="campaign.description">
                <div class="text-caption grey--text">Description</div>
                <div style="white-space: pre-wrap">{{ campaign.description }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <new-tip-kpi-card label="Affectations" :value="campaign.assignments_count" icon="mdi-account-multiple" />
        <new-tip-kpi-card label="Visites" :value="campaign.visits_count" icon="mdi-clipboard-check" class="mt-3" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { formatDate } from '@/helpers/formatters';
import StatusBadge from '@/components/new-tip/StatusBadge.vue';
import KpiCard from '@/components/new-tip/KpiCard.vue';

export default {
  name: 'NewTipCampaignDetail',
  components: { 'new-tip-status-badge': StatusBadge, 'new-tip-kpi-card': KpiCard },
  props: { id: { type: [String, Number], required: true } },
  computed: {
    ...mapState('newTip', { campaign: s => s.currentCampaign }),
    creatorName() {
      const c = this.campaign && this.campaign.creator;
      if (!c) return '—';
      const parts = [c.first_name, c.last_name].filter(Boolean);
      return parts.length ? parts.join(' ') : '—';
    },
  },
  methods: {
    ...mapActions('newTip', ['fetchCampaign']),
    formatDate,
  },
  mounted() { this.fetchCampaign(this.id); },
};
</script>
